import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { RegenerativePractice } from '../_models';
import { environment } from '../../../environments/environment';

@Injectable()
export class PracticesRegenerativeService {
  private regenerativeService = environment.regenerativeServiceUrl;

  $regenerativePractices = new BehaviorSubject<{
    data: RegenerativePractice[];
    totalCount: number;
  }>(null);

  private http = inject(HttpClient);

  getPractices$(): Observable<{ data: RegenerativePractice[]; totalCount: number }> {
    return this.http
      .get<{
        data: RegenerativePractice[];
        totalCount: number;
      }>(`${this.regenerativeService}api/private/v1/practices`)
      .pipe(
        tap((resp) => this.$regenerativePractices.next(resp)),
        shareReplay(1)
      );
  }

  /**
   * @description: Get all practices
   * @returns {Promise<{ data: RegenerativePractice[], totalCount: number }>}
   */
  async getPractices(): Promise<{ data: RegenerativePractice[]; totalCount: number }> {
    try {
      const response = await firstValueFrom(
        this.http.get<{ data: RegenerativePractice[]; totalCount: number }>(
          `${this.regenerativeService}api/private/v1/practices`
        )
      );
      this.$regenerativePractices.next(response); // Aggiorna il BehaviorSubject
      return response;
    } catch (error) {
      console.error('Error fetching practices:', error);
      throw error; // Rilancia l'errore per la gestione a monte
    }
  }

  /**
   * @description: Get the whole object of the practices required
   * @param practiceId: {string}
   * @returns {Promise<{ data: RegenerativePractice[], totalCount: number }>}
   */
  async getPracticeById(
    practiceId: string
  ): Promise<{ data: RegenerativePractice[]; totalCount: number }> {
    try {
      const response = await firstValueFrom(
        this.http.get<{ data: RegenerativePractice[]; totalCount: number }>(
          `${this.regenerativeService}api/private/v1/practices/${practiceId}`
        )
      );
      return response;
    } catch (error) {
      console.error(`Error fetching practice with ID ${practiceId}:`, error);
      throw error;
    }
  }
}
